/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_2_QInputs */

const en_mk_pricing_faq_2_q = /** @type {(inputs: Mk_Pricing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens when a workspace's AI quota runs out?`)
};

const id_mk_pricing_faq_2_q = /** @type {(inputs: Mk_Pricing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang terjadi kalau kuota AI workspace habis?`)
};

/**
* | output |
* | --- |
* | "What happens when a workspace's AI quota runs out?" |
*
* @param {Mk_Pricing_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_2_q = /** @type {((inputs?: Mk_Pricing_Faq_2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_2_q(inputs)
	return en_mk_pricing_faq_2_q(inputs)
});